<div class = "body">

    <div class ="container" style = "height:50px"> </div>
    <div *ngFor="let firm of firmante">
    <div  class = "container principal" style = "background-color: white; padding-top: 50px; padding-bottom:50px">
        <div class = "row">
          <ol>
            <ng-template [ngIf]="firm.tipoFirma == 'PRIMERAFIRMA'" [ngIfElse]="segundo">
              <li class = "row" ><h1><strong>  Primer firmante </strong></h1> </li>     
            </ng-template>
            <ng-template #segundo>
              <li class = "row" > <h1><strong>  Segundo firmante </strong></h1> </li>      
            </ng-template>                 
            <li class = "row"> <h2> Nombre: {{firm.usuarioFirmante}} </h2> </li>           
            <li class = "row"> <h2> Rut: {{firm.rutFirmante}} </h2> </li>         
            <li class = "row"> <h2> Fecha: {{firm.fechaFirma}} Hora: {{firm.horaFirma}}  </h2> </li>  
          </ol>
        </div>       
    </div>
    <br/>
  </div>
      
</div>
